export const restApiUrl = {
  //   dev: 'https://ankete-1-k5635413.deta.app',
  prod: "https://ankete-urilc.ondigitalocean.app",
};
